export class RecupererEtEnregistrerPiecesResultat {
    constructor() {
        this.nombrePiecesRecuperees = 0;
        this.nombrePiecesAjoutees = 0;
        this.nombrePiecesModifiees = 0;
        this.nombrePiecesDejaTransmises = 0;
        this.piecesEnErreur = [];
        this.avertissements = [];
    }

    public nombrePiecesRecuperees: number;
    public nombrePiecesAjoutees: number;
    public nombrePiecesModifiees: number;
    //Pièces modifiées dans le BO mais déjà transmises à la PA : la modification n'est pas reprise
    public nombrePiecesDejaTransmises: number;
    public piecesEnErreur: string[];
    //Une ligne par pièce, à porter à la connaissance de l'utilisateur
    public avertissements: string[];
}
